import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, BookOpen, BarChart3, User, LogOut, Calendar, Bell } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../contexts/NotificationContext';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useAuth();
  const { unreadCount } = useNotifications();

  // Don't render header on login page only
  if (location.pathname === '/login' || location.pathname === '/login/') {
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Don't render header if no user and on login page
  if (!user && (location.pathname === '/login' || location.pathname === '/login/')) {
    return null;
  }

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/welcome" className="logo">
          <div className="logo-container-white">
            <img 
              src="/MeritIQ_logo.jpg" 
              alt="MeritIQ Logo" 
              className="truMerit-logo"
            />
          </div>
        </Link>
        
        {user ? (
          <div className="header-right">
            {location.pathname !== '/welcome' && !location.pathname.startsWith('/prescreening') && (
              <nav className="nav">
                {!isAdmin() ? (
                  <>
                    <Link 
                      to="/dashboard?clearFilters=true" 
                      className={location.pathname === '/dashboard' ? 'active' : ''}
                    >
                      <Home size={16} style={{ marginRight: '8px' }} />
                      Dashboard
                    </Link>
                    <Link 
                      to="/calendar" 
                      className={location.pathname === '/calendar' ? 'active' : ''}
                    >
                      <Calendar size={16} style={{ marginRight: '8px' }} />
                      Training Calendar
                    </Link>
                    <Link 
                      to="/progress" 
                      className={location.pathname === '/progress' ? 'active' : ''}
                    >
                      <BarChart3 size={16} style={{ marginRight: '8px' }} />
                      Progress
                    </Link>
                  </>
                ) : (
                  <Link 
                    to="/admin" 
                    className={location.pathname === '/admin' ? 'active' : ''}
                  >
                    <User size={16} style={{ marginRight: '8px' }} />
                    Admin
                  </Link>
                )}
              </nav>
            )}
            
            <div className="header-actions">
              {!isAdmin() && location.pathname !== '/welcome' && !location.pathname.startsWith('/prescreening') && (
                <Link 
                  to="/notifications" 
                  className={`notification-icon-link ${location.pathname === '/notifications' ? 'active' : ''}`}
                  title="Notifications"
                >
                  <Bell size={20} />
                  {unreadCount > 0 && (
                    <span className="notification-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
                  )}
                </Link>
              )}
            
            <div className="user-info">
              <div className="user-avatar">
                <User size={20} />
              </div>
              <div className="user-details">
                <span className="user-name">{user.name}</span>
                <span className="user-role">({user.role})</span>
              </div>
              <button onClick={handleLogout} className="logout-btn">
                <LogOut size={16} />
              </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
